import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Insert16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M8 4.83478C8.33617 4.83478 8.6087 5.1073 8.6087 5.44348V10.5565C8.6087 10.8927 8.33617 11.1652 8 11.1652C7.66383 11.1652 7.3913 10.8927 7.3913 10.5565V5.44348C7.3913 5.1073 7.66383 4.83478 8 4.83478Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M4.83478 8C4.83478 7.66383 5.1073 7.3913 5.44348 7.3913H10.5565C10.8927 7.3913 11.1652 7.66383 11.1652 8C11.1652 8.33617 10.8927 8.6087 10.5565 8.6087H5.44348C5.1073 8.6087 4.83478 8.33617 4.83478 8Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85651 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85651 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85651 15 8 15C6.14348 15 4.36301 14.2625 3.05025 12.9497C1.7375 11.637 1 9.85651 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025ZM8 2.21739C6.46636 2.21739 4.99553 2.82663 3.91108 3.91108C2.82663 4.99553 2.21739 6.46636 2.21739 8C2.21739 9.53364 2.82663 11.0045 3.91108 12.0889C4.99553 13.1734 6.46636 13.7826 8 13.7826C9.53364 13.7826 11.0045 13.1734 12.0889 12.0889C13.1734 11.0045 13.7826 9.53364 13.7826 8C13.7826 6.46636 13.1734 4.99553 12.0889 3.91108C11.0045 2.82663 9.53364 2.21739 8 2.21739Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
